// Where a member stands, on the Library's tile for a mastermind they have (the Accelerator critique's member 17; Adam's
// yes of 22 Oct): the level's own word, On track, A little behind, Behind or Well behind, as their log has it
// (src/products/mastermind/levels.js: the automatic level, or the level Adam set by hand over it). Never anything of the guarantee:
// it's worked out from the member's own log, which holds none of it since migration 81, the same way their home and log
// work it out. Getting started (nothing held or due yet) has no word on the tile.
//
// Pure: no network, no clock, so a test can import it as it is. load.js loadLevels reads the logs, after the Library
// has shown and never waited on (app/member.jsx), only for the products levelProducts names; model.js puts the word on
// the tile.
import { accountability } from '../products/mastermind/log.js'
import { LOG } from '../products/mastermind/logWords.js'
import { guaranteeOf } from '../products/accelerator/model.js'

// How long the Library's tile waits for a log: an answer later than this gives no word
export const LEVEL_WAIT_MS = 2500
// How long a log read here or on the Accelerator's pages is used again before it's read afresh
export const LEVEL_FRESH_MS = 5 * 60e3
const SHOWN = ['on_track', 'a_little_behind', 'behind', 'well_behind']

// The tile's word for a level's key ("Behind"), the log's own, or null for Getting started or anything else
export const levelWord = key => (SHOWN.includes(key) ? LOG.state[key] : null)

// A log's level's key, as the member's own pages work it out (log.js accountability, with a level set by hand over the
// automatic 1), or null for Getting started, no log or anything that isn't 1
export function levelOfLog(doc) {
  if (!doc || typeof doc !== 'object' || Array.isArray(doc)) return null
  try {
    const key = accountability(doc).level?.key
    return SHOWN.includes(key) ? key : null
  } catch {
    return null
  }
}

// The masterminds whose tile says where they stand, from the Library's rows: live, open to them now (an access row
// active and not past its end) and showing members where they stand (the home's own setting, guaranteeOf). Only these
// are read, so nobody else's Library asks for anything more.
export function levelProducts(d, nowMs) {
  if (!Array.isArray(d?.products) || !Array.isArray(d?.access)) return []
  const shown = new Set(d.products.filter(p => p.type === 'mastermind' && p.state === 'live' && p.access_kind === 'paid' && guaranteeOf(p)).map(p => p.id))
  return [...new Set(d.access
    .filter(a => a.status === 'active' && shown.has(a.product_id) && !(a.ends_at && Date.parse(a.ends_at) <= nowMs))
    .map(a => a.product_id))]
}
